<template>
    <Modal :title="'Fatura Address Bilgileri'" @cancel="cancelAction" :show-footer="false">
        <div class="card-modal">
            <div class="card-input">
                <div class="text">Fatura Türü</div>
                <div class="card-input">
                    <a-select style="width: 100%" v-model="billingType">
                        <a-select-option v-for="type of types" :value="type.key" :key="type.key">
                            {{ type.label }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="card-input flex" v-if="billingType === 'individual'">
                <div class="flex-child">
                    <div class="text">İsim</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="name" />
                    </div>
                </div>
                <div class="flex-child">
                    <div class="text">Soyisim</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="surname" />
                    </div>
                </div>
            </div>
            <div class="card-input flex" v-if="billingType === 'company'">
                <div class="flex-child">
                    <div class="text">Şirket Adı</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="name" />
                    </div>
                </div>
            </div>
            <div class="card-input flex">
                <div class="flex-child">
                    <div class="text">Email</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="mail" />
                    </div>
                </div>
                <div class="flex-child" v-if="billingType !== 'company'">
                    <div class="text">TC Kimlik</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="idenity" />
                    </div>
                </div>
            </div>
            <div class="card-input flex" v-if="billingType === 'company'">
                <div class="flex-child" style="margin-right: 5px">
                    <div class="text">Vergi Dairesi</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-auto-complete
                            v-model="taxOffice"
                            :data-source="taxOffices"
                            style="width: 100%"
                            @search="onSearch"
                        />
                    </div>
                </div>
                <div class="flex-child">
                    <div class="text">Vergi Numarası</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="taxNumber" />
                    </div>
                </div>
            </div>
            <div class="card-input flex">
                <div class="flex-child">
                    <div class="text">Ülke</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="country" />
                    </div>
                </div>
                <div class="flex-child">
                    <div class="text">Şehir</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="city" />
                    </div>
                </div>
            </div>
            <div class="card-input">
                <div class="text">Address</div>
                <div class="card-input">
                    <a-textarea v-model="address" show-count :maxlength="150" />
                </div>
            </div>
            <div style="display: flex; justify-content: end; align-items: center; margin-top: 20px">
                <div class="supsis-modal-button" @click="cancelAction">İptal</div>
                <div class="supsis-modal-button second" @click="createAction">Kaydet</div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import { mapState } from "vuex";
import TaxOffices from "../../utils/taxOffices";

export default {
    name: "UpdateBillingModal",
    components: {
        Modal,
    },
    data: () => ({
        taxOffices: [],
        billingType: "company",
        name: null,
        surname: null,
        idenity: null,
        mail: null,
        country: null,
        city: null,
        address: null,
        taxNumber: null,
        taxOffice: null,
        types: [
            {
                key: "company",
                label: "Şirket",
            },
            {
                key: "individual",
                label: "Şahıs",
            },
        ],
    }),
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
        }),
    },
    mounted() {
        if (this.billingDetail) {
            this.billingType = this.billingDetail.billingType;
            this.name = this.billingDetail.name;
            this.surname = this.billingDetail.surname;
            this.address = this.billingDetail.billingAddress;
            this.country = this.billingDetail.billingCountry;
            this.city = this.billingDetail.billingCity;
            this.mail = this.billingDetail.email;
            this.idenity = this.billingDetail.identityNumber;
            this.taxNumber = this.billingDetail.taxNumber;
            this.taxOffice = this.billingDetail.taxOffice;
        }
    },
    methods: {
        onSearch(searchText) {
            this.taxOffices =
                !searchText || searchText.length < 2
                    ? TaxOffices.slice(0, 5)
                    : TaxOffices.filter((s) => s.toUpperCase().includes(searchText.toUpperCase()));
        },
        cancelAction() {
            this.$emit("cancel");
        },
        createAction() {
            this.$emit("create", {
                billingType: this.billingType,
                name: this.name,
                surname: this.surname,
                idenity: this.idenity,
                mail: this.mail,
                country: this.country,
                city: this.city,
                address: this.address,
                taxNumber: this.taxNumber,
                taxOffice: this.taxOffice,
            });
        },
    },
};
</script>
<style lang="scss">
.card-modal {
    .card-input {
        .text {
            font-weight: bold;
        }

        .supsis-input {
            width: 100%;
            border: none;
            padding: 4px 8px;
            border-radius: 8px;
        }

        &.flex {
            display: flex;
            width: 100%;

            .flex-child {
                width: 100%;
                margin-right: 5px;
            }
        }
    }

    .supsis-modal-button {
        background: #ffffff00;
        border: 1px solid #bbbbbb;
        border-radius: 100px;
        padding: 5px 30px;
        margin-right: 4px;
        cursor: pointer;
        user-select: none;

        &.second {
            background: #ec4b1d;
            color: white;
            border: none;
        }
    }
}
</style>
